export const UserEnum = ["ADMIN", "MANAGER", "TEACHER", "PARENT", "STUDENT", "STAFF", "SALER", "ACCOUNTANT", "SUPER_ACCOUNTANT", "FOREIGN_ELEMENTS", "HR"];
